import React, { Suspense } from 'react';
import arePropsEqual from 'react-fast-compare';
import { Trans, TransProps, useTranslation } from 'react-i18next';
import type { TOptions } from 'i18next';
import { DEFAULT_LOCIZE_NAMESPACE } from '../../constants';

interface Props extends TransProps<any> {
  fallback?: string;
  namespace?: string;
  tOptions?: TOptions;
  values?: Record<string, any>;
  children?: any;
}

export const Local = ({
  namespace = DEFAULT_LOCIZE_NAMESPACE,
  tOptions = {},
  values = {},
  fallback,
  children,
  ...props
}: Props) => (
  <Suspense fallback={<>{fallback ?? children}</>}>
    <SuspendedLocal
      namespace={namespace}
      values={values}
      tOptions={tOptions}
      {...props}
    >
      {children}
    </SuspendedLocal>
  </Suspense>
);

const SuspendedLocal = ({ children, namespace, tOptions, ...props }: Props) => {
  const { t } = useTranslation(namespace);

  return (
    <Trans
      t={t}
      ns={namespace}
      i18nKey={children}
      tOptions={tOptions}
      {...props}
    >
      {children}
    </Trans>
  );
};

export default React.memo(Local, arePropsEqual);
